import { useMutation, MutationHookOptions } from '@apollo/react-hooks';
import { REVOKE_RESOURCE_ACCESS_MUTATION } from '@frontend/app/queries';
import {
  RevokeResourceAccessMutation,
  RevokeResourceAccessMutationVariables,
} from '@frontend/app/queries/types/RevokeResourceAccessMutation';

type TOptions = MutationHookOptions<RevokeResourceAccessMutation, RevokeResourceAccessMutationVariables>;

export const useRevokeResourceAccessMutation = (options: TOptions = {}) =>
  useMutation<RevokeResourceAccessMutation, RevokeResourceAccessMutationVariables>(
    REVOKE_RESOURCE_ACCESS_MUTATION,
    options,
  );
